module.exports = __webpack_public_path__ + "img/part_6_2.a84d1e46.webp";